export default require('../../client/death/certificate/CertificateOptionsPage')
  .default;
